import React, {useEffect, useRef, useState} from "react";
import {Clip, Highlight, SocialClip} from "../../types/clipTypes";
import VideoEditorPopupHeader from "../EditorPopup/EditorPopupHeader";
import StyledPopup from "../CommonComponents/StyledPopup/StyledPopup";
import {EditorState} from "../../types/editor";
import SpinnerBox from "../CommonComponents/SpinnerBox/SpinnerBox";
import SocialPublish from "./SocialPublish";
import {getEditStateById} from "../../queries/editorQueries";
import {getEditCoordinates, getNumericAspectRatio} from "../../utils/utils";
import {AspectRatio} from "../../types/generic";
import {getSocialClipsByEditState} from "../../queries/socialQueries";

interface SocialPublishPopupProps {
    clip: Clip | Highlight;
    socialClip: SocialClip;
    isOpen: boolean;
    onClose: () => void;
}

const SocialPublishPopup: React.FC<SocialPublishPopupProps> = ({socialClip, clip, isOpen, onClose}) => {
    const [loadingEditState, setLoadingEditState] = useState<boolean>(false);
    const [defaultAspectRatio, setDefaultAspectRatio] = useState<AspectRatio>();
    const [editState, setEditState] = useState<EditorState>();
    const [socialClips, setSocialClips] = useState<Record<number, SocialClip>>({});
    const [availableAspectRatio, setAvailableAspectRatio] = useState<AspectRatio[]>([]);

    function handleClose(){
        onClose();
        setDefaultAspectRatio(undefined);
        setEditState(undefined);
        setSocialClips([]);
        setAvailableAspectRatio([])
    }

    useEffect(() => {
        const startLoad = async () => {
            try{
                setLoadingEditState(true)
                const promiseArray = [getEditStateById(socialClip.edit_state_id), getSocialClipsByEditState(socialClip.edit_state_id)];
                const response = await Promise.all(promiseArray);
                setDefaultAspectRatio({
                    label: String(socialClip.aspect_ratio),
                    numeric: getNumericAspectRatio(String(socialClip.aspect_ratio)),
                    disabled: false
                })
                setEditState(response[0] as EditorState);
                const tempSocialClips = response[1] as SocialClip[];
                const tempSocialClipDict: Record<number, SocialClip> = {}
                const tempAvailableAspectRatio = [...availableAspectRatio];
                for (const socialClip of tempSocialClips){
                    tempSocialClipDict[socialClip.aspect_ratio] = socialClip;
                    tempAvailableAspectRatio.push({
                        label: String(socialClip.aspect_ratio),
                        numeric: getNumericAspectRatio(String(socialClip.aspect_ratio)),
                        disabled: false
                    })
                }
                setAvailableAspectRatio(tempAvailableAspectRatio);
                setSocialClips(tempSocialClipDict);
            }catch (e){
                console.error(e);
            }finally {
                setLoadingEditState(false);
            }
        }
        if(isOpen){
            startLoad();
        }
    }, [isOpen]);

    return(
        <StyledPopup
            width={'60vw'}
            isOpen={isOpen}
            onClose={handleClose}
            title={!loadingEditState && editState && editState.trim_points ? <VideoEditorPopupHeader trimPoints={editState.trim_points} title={"Social Publication"} clip={clip}/> : <></>}
        >
            {loadingEditState && <SpinnerBox height={'80vh'} text={'Loading'}/>}
            {!loadingEditState && editState && defaultAspectRatio &&
                <SocialPublish
                    clip={clip}
                    aspectRatios={availableAspectRatio}
                    coordinates={getEditCoordinates(editState.trim_points, editState.coordinates, clip.frame_rate ? clip.frame_rate : 0 )}
                    socialClips={socialClips}
                    defaultAspectRatio={defaultAspectRatio}
                />
            }
        </StyledPopup>
    )
}

export default SocialPublishPopup